/**
 * IconHouseGuestMale - Male symbol (♂) with candy heart design
 * Features: glossy candy-neon style, breathing animation, soft glow
 */
export function IconHouseGuestMale({ className = '', isHovered = false }) {
  return (
    <svg
      viewBox="0 0 80 80"
      className={`transition-all duration-500 ${className}`}
      style={{
        filter: isHovered 
          ? 'drop-shadow(0 0 20px rgba(39, 215, 255, 0.8)) drop-shadow(0 0 35px rgba(139, 92, 255, 0.5))'
          : 'drop-shadow(0 0 12px rgba(39, 215, 255, 0.6)) drop-shadow(0 0 25px rgba(139, 92, 255, 0.3))'
      }}
    >
      <defs>
        {/* Main candy gradient - cyan to purple */}
        <linearGradient id="maleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#27D7FF" />
          <stop offset="50%" stopColor="#8B5CFF" />
          <stop offset="100%" stopColor="#FF4DA6" />
        </linearGradient>
        
        {/* Glossy highlight */}
        <linearGradient id="maleHighlight" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.6)" />
          <stop offset="40%" stopColor="rgba(255,255,255,0.1)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </linearGradient>
        
        {/* Soft glow filter */}
        <filter id="maleGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
        
        {/* Arrow head marker */}
        <marker id="maleArrowHead" markerWidth="12" markerHeight="12" refX="6" refY="6" orient="auto">
          <path d="M0,0 L12,6 L0,12 L3,6 Z" fill="url(#maleGradient)" />
        </marker>
      </defs>
      
      {/* Heart-shaped candy body (replacing circle in ♂) */}
      <g filter="url(#maleGlow)">
        {/* Heart shape - centered lower */}
        <path
          d="M40 65 C20 50, 12 35, 20 25 C26 17, 35 18, 40 28 C45 18, 54 17, 60 25 C68 35, 60 50, 40 65 Z"
          fill="url(#maleGradient)"
          className="animate-breathe"
          style={{ transformOrigin: 'center center' }}
        />
        
        {/* Glossy highlight on heart */}
        <path
          d="M40 60 C24 48, 18 36, 24 28 C28 22, 35 23, 40 30 C40 30, 40 30, 40 30 C35 23, 28 22, 24 28 C18 36, 24 48, 40 60 Z"
          fill="url(#maleHighlight)"
          opacity="0.5"
        />
        
        {/* Arrow shaft - going to top right */}
        <line
          x1="50"
          y1="30"
          x2="68"
          y2="12"
          stroke="url(#maleGradient)"
          strokeWidth="4"
          strokeLinecap="round"
        />
        
        {/* Arrow head */}
        <polygon
          points="62,8 75,5 72,18"
          fill="url(#maleGradient)"
        />
        
        {/* Small sparkle accent */}
        <circle cx="70" cy="8" r="2" fill="white" opacity="0.8">
          <animate attributeName="opacity" values="0.8;0.3;0.8" dur="2s" repeatCount="indefinite" />
        </circle>
      </g>
    </svg>
  );
}

export default IconHouseGuestMale;
